module.exports = __webpack_public_path__ + "media/images/icons/account-login-3add71aa783b72b6c9b4a4f3c8df8376.svg";